/**
 * Resolve the deployment timezone (IANA name) — `featureStore.defaultTimezone`
 * from `GET /api/features`'s `default_timezone`, `'UTC'` until the manifest
 * loads. A naive datetime field value is wall time in this zone (SA-406 D1).
 * Mirrors `useDefaultCurrency.ts`.
 */

import { useFeatureStore } from '@/stores/featureStore'

const DEFAULT_TIMEZONE = 'UTC'

export function useDefaultTimezone(): string {
  return useFeatureStore(s => s.defaultTimezone) || DEFAULT_TIMEZONE
}

/** Non-React accessor (services, event handlers, etc.). */
export function getDefaultTimezone(): string {
  return useFeatureStore.getState().defaultTimezone || DEFAULT_TIMEZONE
}
